import { createSlice } from '@reduxjs/toolkit'
import {
  Barcode12Atelier98_Si,
  Barcode14Tipo_Mav,
  BarcodeClientiTipo_Tek,
  EAN13Atelier98_Siepuri,
  Barcode13Come12_No,
  BarcodeGrigliaVentilazione_No,
  CodicePersonalizzazione_Fabi,
} from '../Constants/Barcode'
import {
  HideAvailability,
  HideBarcodeElement,
  HideDimensionLocal,
  HideDimensionNearby,
  HideDimensionRemote,
  HideEdit,
  HideExtraFilters,
  HideFilterElement,
  HideInterrogationType,
  HideMarketplace,
  HideMovement,
  HideOptionalFilters,
  HidePredefinedFilters,
  HidenPriceFilters,
  HideQuantities,
  HideWebAndMarketingFilters,
  HideWorkspaceDropdown,
  configurationActiveStore,
  configurationHiddenElements,
  IsSaveBarcode,
  LightTheme,
  UiCodeEnableAvailabilityView,
  UiCodeEnableEdit,
  UiCodeEnableMovementLog,
  UiCodeEnableMovements,
  UiCodeEnableTabAvailabilities,
  UiCodeEnableTabMovements,
  UiCodeEnableTabSituazione,
  UiCodeVersionNumber,
  HideFiltersNotActiveForQuantities,
  HideUnlockMovementButton,
  configurationHiddenQuantitiesFilter,
  configurationGridLayout,
  HidePrices,
  HideQuantityLimits,
  HideDiwaReactGridLayoutColumnsBtn,
  UiCodePricesOmnichannel,
  configurationTheme,
  HidePIMIMages,
  Stores,
  ProfilesKeys,
  UiCodePIM,
  PricelistTypeFilter,
} from '../Constants/Configuration'
import { WorkSpace, WorkSpaces } from '../Constants/WorkSpace'
import {
  checkLocalStorageWorkspaceElementVisibility,
  checkOmnichannelAndPricesVisibility,
  checkPIMVisibility,
  checkPricelistTypeFilter,
  checkSettingsVisibility,
  checkPricesSingleTab,
  checkOmniPricesSingleTab,
  checkWorkspaceMarketplaceVisibility,
  checkWorkspaceSitesVisibility,
  checkWorkspaceStoresVisibility,
  decryptLocalStorageValue,
  encryptLocalStorageValue,
  getStorageValue,
  isOmniVisible,
  removeStorageValue,
  setStorageValue,
} from '../Helpers/ConfigurationHelper'
import { ArticleColumn } from 'Constants/TableConfiguration'

export const configurationSlice = createSlice({
  name: 'configuration',
  initialState: {
    CodicePersonalizzazione: CodicePersonalizzazione_Fabi, //FABI, MARILLI
    BarcodeClientiTipo: BarcodeClientiTipo_Tek, //CUF, MAV, CUF911, IN2011, OLI6, AVI5
    Barcode12Atelier98: Barcode12Atelier98_Si, //no, SwedaMaster, SiEPuri
    Barcode13Come12: Barcode13Come12_No,
    EAN13Atelier98: EAN13Atelier98_Siepuri, //13come8, Nara
    Barcode14Tipo: Barcode14Tipo_Mav,
    BarcodeGrigliaVentilazione: BarcodeGrigliaVentilazione_No,
    LabelClickOnFilters: true,
    Currencies: [],
    activeStore: Stores.Local as string,
    isEditVisible: false,
    isUnlockMovementsVisible: false,
    isTabMovementVisible: false,
    isTabAvailabilityVisibile: false,
    isMovementLogVisible: false,
    isMarketplaceAvailabilitiesEnable: false,
    isSuperCategoryEnabled: false,
    currentConfiguration: '',
    publicWorkspace: null,
    profileWorkspaces: null,
    isConfigurationModalOpen: false,
    isConfigurationEditModalOpen: false,
    defaultProfileOptions: [],
    formConfigurationValue: '',
    appVersion: '',
    allMarketplace: [],
    profileValue: ProfilesKeys.SuperProfile, //set as super profile by default to prevent web call without profile
    userValue: '',
    GDPR: false,
    omnichannelModule: true,
    omnichannelStoreModule: true,
    omnichannelSiteModule: true,
    pimModule: true,
    limitQtyModule: true,
    causaliAmmesse: '',
    negoziContoVendita: '',
    negozioHome: '',
    negoziVicini: '',
    negoziLontani: '',
    negoziEscludere: '',
    showB2BLine: true,
    isTabQuantitiesVisibile: true,
    activeTheme: LightTheme,
    isPurchasePriceVisibile: true,
    webAndMarketingFiltersVisible: false,
    //workspace visibility variables
    workspaceQuantitiesFilterToHide: [],
    workspaceFilterElementVisible: true,
    workspaceBarcodeElementVisible: true,
    workspaceDimensionLocalVisible: true,
    workspaceDimensionNearbyVisible: true,
    workspaceDimensionRemoteVisible: true,
    workspaceInterrogationTypeElementVisible: true,
    workspaceWorkspaceDropdownVisible: true,
    workspaceQuantitiesFiltersNotActiveVisible: true,
    workspaceUnlockMovementButtonVisible: true,
    workspaceQuantitiesVisible: true,
    workspaceMovementVisible: true,
    workspaceAvailabilityVisible: true,
    workspaceMarketplaceAvailabilitiesVisible: true,
    workspaceDiwaEditVisible: true,
    workspacePricesVisible: true,
    workspaceQuantityLimitVisible: true,
    workspaceDiwaReactGridLayoutColumnsBtnVisibile: true,
    workspaceImagesVisible: true,
    //workspace side filter visibility variables
    workspacePredefinedFiltersVisible: true,
    workspaceExtraFiltersVisible: true,
    workspacePriceFiltersVisible: true,
    workspaceOptionalFiltersVisible: true,
    workspaceWebAndMarketingFiltersVisible: true,
    integrationInfo: '',
    //Section Variables
    isOmnichannelAndPricesVisibile: false,
    settingsVisibility: false,
    isImagesVisible: false,
    isFromMV: false,
    isOmnichannelVisible: false, //omni visibility alone, different from isOmnichannelAndPricesVisibile
    //Functionalities
    //Da rivedere meglio sites e stores, 'Default' non entra in loadConfiguration
    sites: false,
    stores: false,
    marketplace: false,
    isPricesSingleTab: false,
    isOmniPricesSingleTab: false,
    allPricelists: [],
    pricelistTypeFilter: PricelistTypeFilter.ALL,
  },
  reducers: {
    saveIntegrationInfo: (state, action) => {
      state.integrationInfo = state.integrationInfo + (state.integrationInfo ? '~~' : '') + action.payload.value
      console.log(state.integrationInfo)
    },
    isFromMVMode: (state, action) => {
      state.isFromMV = action.payload
    },
    setValue: (state, action) => {
      if (action.payload.key) {
        state[action.payload.key] = action.payload.value
      }
    },
    setActiveStore: (state, action) => {
      state.activeStore = action.payload
    },
    loadConfiguration: (state, action) => {
      //load all workspace config options
      state.currentConfiguration = action.payload.configurationName

      const storedActiveStore = decryptLocalStorageValue(
        action.payload.configurationName + configurationActiveStore,
        action.payload.user,
        action.payload.serverConfig,
      )
      state.activeStore = storedActiveStore ? storedActiveStore : Stores.Local

      const hiddenElements = decryptLocalStorageValue(
        action.payload.configurationName + configurationHiddenElements,
        action.payload.user,
        action.payload.serverConfig,
      )

      //Hidden Element Rule: Profile options form database always won on saved option
      //If there is storage workspace option that hidden, check profile option rule first: set that if element is hidden else storage option
      //If the database rule don't exist take show/hidden value from storage

      state.workspaceFilterElementVisible = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HideFilterElement,
      )
      state.workspaceBarcodeElementVisible = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HideBarcodeElement,
      )
      state.workspaceDimensionLocalVisible = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HideDimensionLocal,
      )
      state.workspaceDimensionNearbyVisible = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HideDimensionNearby,
      )
      state.workspaceDimensionRemoteVisible = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HideDimensionRemote,
      )
      state.workspaceInterrogationTypeElementVisible = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HideInterrogationType,
      )
      state.workspaceWorkspaceDropdownVisible = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HideWorkspaceDropdown,
      )
      state.workspacePredefinedFiltersVisible = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HidePredefinedFilters,
      )
      state.workspaceExtraFiltersVisible = checkLocalStorageWorkspaceElementVisibility(hiddenElements, HideExtraFilters)
      state.workspacePriceFiltersVisible = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HidenPriceFilters,
      )
      state.workspaceOptionalFiltersVisible = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HideOptionalFilters,
      )
      state.workspaceWebAndMarketingFiltersVisible = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HideWebAndMarketingFilters,
      )
      state.workspaceImagesVisible = checkLocalStorageWorkspaceElementVisibility(hiddenElements, HidePIMIMages)
      state.workspaceQuantitiesFiltersNotActiveVisible = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HideFiltersNotActiveForQuantities,
      )
      state.workspaceUnlockMovementButtonVisible = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HideUnlockMovementButton,
      )

      const hiddenQuantitiesFilters = decryptLocalStorageValue(
        action.payload.configurationName + configurationHiddenQuantitiesFilter,
        action.payload.user,
        action.payload.serverConfig,
      )

      state.workspaceQuantitiesFilterToHide =
        hiddenQuantitiesFilters && hiddenQuantitiesFilters.length > 0 ? JSON.parse(hiddenQuantitiesFilters) : []

      //duplicated because shared with profile options
      state.workspaceQuantitiesVisible = checkLocalStorageWorkspaceElementVisibility(hiddenElements, HideQuantities)
      state.workspaceMovementVisible = checkLocalStorageWorkspaceElementVisibility(hiddenElements, HideMovement)
      state.workspaceAvailabilityVisible = checkLocalStorageWorkspaceElementVisibility(hiddenElements, HideAvailability)
      state.workspaceMarketplaceAvailabilitiesVisible = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HideMarketplace,
      )
      state.workspaceDiwaEditVisible = checkLocalStorageWorkspaceElementVisibility(hiddenElements, HideEdit)
      state.workspacePricesVisible = checkLocalStorageWorkspaceElementVisibility(hiddenElements, HidePrices)
      state.workspaceQuantityLimitVisible = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HideQuantityLimits,
      )

      state.workspaceDiwaReactGridLayoutColumnsBtnVisibile = checkLocalStorageWorkspaceElementVisibility(
        hiddenElements,
        HideDiwaReactGridLayoutColumnsBtn,
      )

      state.pricelistTypeFilter = checkPricelistTypeFilter(state.publicWorkspace)
    },
    loadProfileOptions: (state, action) => {
      //load all config referred from database

      if (action.payload.defaultProfileOptions && state.defaultProfileOptions.length === 0) {
        state.defaultProfileOptions = action.payload.defaultProfileOptions
      }

      if (state.defaultProfileOptions.length !== 0) {
        const editVisibility = state.defaultProfileOptions.find(option => option.uiCode === UiCodeEnableEdit)
        const situationVisibility = state.defaultProfileOptions.find(
          option => option.uiCode === UiCodeEnableTabSituazione,
        )
        const unlockMovementsVisibility = state.defaultProfileOptions.find(
          option => option.uiCode === UiCodeEnableMovements,
        )
        const movementTabVisibility = state.defaultProfileOptions.find(
          option => option.uiCode === UiCodeEnableTabMovements,
        )
        const availabilityTabVisibility = state.defaultProfileOptions.find(
          option => option.uiCode === UiCodeEnableAvailabilityView,
        )
        const movementLogVisibility = state.defaultProfileOptions.find(
          option => option.uiCode === UiCodeEnableMovementLog,
        )
        const isMarketplaceAvailaibilitiesEnable = state.defaultProfileOptions.find(
          option => option.uiCode === UiCodeEnableTabAvailabilities,
        )
        const isPricesOmichannelVisibile = state.defaultProfileOptions.find(
          option => option.uiCode === UiCodePricesOmnichannel,
        )

        const isImagesDescriptionTabVisible = state.defaultProfileOptions.find(option => option.uiCode === UiCodePIM)

        state.isSuperCategoryEnabled = state.defaultProfileOptions.some(
          (option: { uiCode: string; active: boolean }) =>
            option.uiCode.toLowerCase() === ArticleColumn.SuperCategory.toLowerCase() && option.active,
        )

        const appVersion = state.defaultProfileOptions.find(option => option.uiCode === UiCodeVersionNumber)

        if (editVisibility) {
          state.isEditVisible = editVisibility.active
        }

        if (situationVisibility) {
          state.isTabQuantitiesVisibile = situationVisibility.active
        }

        if (unlockMovementsVisibility) {
          //when configuration is gruccia, unlockMovementation is always active even if profile option value hidden the element
          state.isUnlockMovementsVisible =
            action.payload.configurationName === WorkSpace.GRUCCIA || unlockMovementsVisibility.active
        }

        if (movementTabVisibility) {
          state.isTabMovementVisible = movementTabVisibility.active
        }

        if (availabilityTabVisibility) {
          state.isTabAvailabilityVisibile = availabilityTabVisibility.active
        }

        if (movementLogVisibility) {
          state.isMovementLogVisible = movementLogVisibility.active
        }

        if (isMarketplaceAvailaibilitiesEnable) {
          state.isMarketplaceAvailabilitiesEnable = isMarketplaceAvailaibilitiesEnable.active
        }

        if (isPricesOmichannelVisibile) {
          state.isOmnichannelAndPricesVisibile =
           (state.omnichannelModule || state.omnichannelSiteModule || state.omnichannelStoreModule)  &&
            isPricesOmichannelVisibile.active &&
            checkOmnichannelAndPricesVisibility(state.publicWorkspace)
        }

        if (isImagesDescriptionTabVisible) {
          state.isImagesVisible =
            state.pimModule && isImagesDescriptionTabVisible.active && checkPIMVisibility(state.publicWorkspace)
        }

        if (appVersion) {
          state.appVersion = appVersion.value
        }

        state.sites = checkWorkspaceSitesVisibility(state.publicWorkspace) && state.omnichannelSiteModule
        state.stores = checkWorkspaceStoresVisibility(state.publicWorkspace) && state.omnichannelStoreModule
        state.marketplace = checkWorkspaceMarketplaceVisibility(state.publicWorkspace) && state.omnichannelModule
        state.settingsVisibility = checkSettingsVisibility(state.publicWorkspace)
        state.isPricesSingleTab = checkPricesSingleTab(state.publicWorkspace)
        state.isOmniPricesSingleTab = checkOmniPricesSingleTab(state.publicWorkspace)
        state.isOmnichannelVisible = isOmniVisible(state.publicWorkspace)
      }
    },
    saveConfiguration: (state, action) => {
      encryptLocalStorageValue(
        action.payload.currentConfiguration + configurationActiveStore,
        state.activeStore,
        action.payload.user,
        action.payload.serverConfig,
      )

      if (state.profileValue === ProfilesKeys.SuperProfile) {
        const hiddenAreaObj = [
          !state.workspaceQuantitiesVisible ? HideQuantities : null,
          !state.workspaceMovementVisible ? HideMovement : null,
          !state.workspaceAvailabilityVisible ? HideAvailability : null,
          !state.workspaceMarketplaceAvailabilitiesVisible ? HideMarketplace : null,

          !state.workspaceFilterElementVisible ? HideFilterElement : null,
          !state.workspaceBarcodeElementVisible ? HideBarcodeElement : null,
          !state.workspaceDimensionLocalVisible ? HideDimensionLocal : null,
          !state.workspaceDimensionNearbyVisible ? HideDimensionNearby : null,
          !state.workspaceDimensionRemoteVisible ? HideDimensionRemote : null,
          !state.workspaceInterrogationTypeElementVisible ? HideInterrogationType : null,
          !state.workspaceWorkspaceDropdownVisible ? HideWorkspaceDropdown : null,
          !state.workspacePredefinedFiltersVisible ? HidePredefinedFilters : null,
          !state.workspaceExtraFiltersVisible ? HideExtraFilters : null,
          !state.workspacePriceFiltersVisible ? HidenPriceFilters : null,
          !state.workspaceOptionalFiltersVisible ? HideOptionalFilters : null,
          !state.webAndMarketingFiltersVisible ? HideWebAndMarketingFilters : null,

          !state.workspaceQuantitiesFiltersNotActiveVisible ? HideFiltersNotActiveForQuantities : null,
          !state.workspaceUnlockMovementButtonVisible ? HideUnlockMovementButton : null,
          !state.workspaceDiwaEditVisible ? HideEdit : null,
          !state.workspacePricesVisible ? HidePrices : null,
          !state.workspaceQuantityLimitVisible ? HideQuantityLimits : null,
          !state.workspaceDiwaReactGridLayoutColumnsBtnVisibile ? HideDiwaReactGridLayoutColumnsBtn : null,
          !state.workspaceImagesVisible ? HidePIMIMages : null,
        ]

        encryptLocalStorageValue(
          action.payload.currentConfiguration + configurationHiddenElements,
          JSON.stringify(hiddenAreaObj.filter(x => x)),
          action.payload.user,
          action.payload.serverConfig,
        )
      }

      const hiddenQuantities = decryptLocalStorageValue(
        state.currentConfiguration + configurationHiddenQuantitiesFilter,
        action.payload.user,
        action.payload.serverConfig,
      )

      encryptLocalStorageValue(
        action.payload.currentConfiguration + configurationHiddenQuantitiesFilter,
        hiddenQuantities ? hiddenQuantities : JSON.stringify([]),
        action.payload.user,
        action.payload.serverConfig,
      )

      const hiddenElements = decryptLocalStorageValue(
        state.currentConfiguration + configurationHiddenElements,
        action.payload.user,
        action.payload.serverConfig,
      )

      encryptLocalStorageValue(
        action.payload.currentConfiguration + configurationHiddenElements,
        hiddenElements ? hiddenElements : JSON.stringify([]),
        action.payload.user,
        action.payload.serverConfig,
      )

      state.currentConfiguration = action.payload.currentConfiguration
    },
    savePublicWorkspace: (state, action) => {
      state.publicWorkspace = action.payload
    },
    saveProfileWorkspaces: (state, action) => {
      state.profileWorkspaces = action.payload
    },
    deleteConfiguration: (state, action) => {
      removeStorageValue(
        action.payload.configurationName + configurationActiveStore,
        action.payload.user,
        action.payload.serverConfig,
      )

      const hiddenQuantities = getStorageValue(
        action.payload.configurationName + configurationHiddenQuantitiesFilter,
        action.payload.user,
        action.payload.serverConfig,
      )
      if (hiddenQuantities) {
        removeStorageValue(
          action.payload.configurationName + configurationHiddenQuantitiesFilter,
          action.payload.user,
          action.payload.serverConfig,
        )
      }

      const hiddenElements = getStorageValue(
        action.payload.configurationName + configurationHiddenElements,
        action.payload.user,
        action.payload.serverConfig,
      )
      if (hiddenElements) {
        removeStorageValue(
          action.payload.configurationName + configurationHiddenElements,
          action.payload.user,
          action.payload.serverConfig,
        )
      }

      const storedGridLayout = getStorageValue(
        action.payload.configurationName + configurationGridLayout,
        action.payload.user,
        action.payload.serverConfig,
      )
      if (storedGridLayout) {
        removeStorageValue(
          action.payload.configurationName + configurationGridLayout,
          action.payload.user,
          action.payload.serverConfig,
        )
      }
    },
    renameConfiguration: (state, action) => {
      if (state.currentConfiguration === action.payload.before) {
        state.currentConfiguration = action.payload.after
      }

      const oldActiveStore = getStorageValue(
        action.payload.before + configurationActiveStore,
        action.payload.user,
        action.payload.serverConfig,
      )

      setStorageValue(
        action.payload.after + configurationActiveStore,
        action.payload.user,
        action.payload.serverConfig,
        oldActiveStore,
      )

      removeStorageValue(
        action.payload.before + configurationActiveStore,
        action.payload.user,
        action.payload.serverConfig,
      )

      const oldHiddenElements = getStorageValue(
        action.payload.before + configurationHiddenElements,
        action.payload.user,
        action.payload.serverConfig,
      )
      if (oldHiddenElements) {
        setStorageValue(
          action.payload.after + configurationHiddenElements,
          action.payload.user,
          action.payload.serverConfig,
          oldHiddenElements,
        )

        removeStorageValue(
          action.payload.before + configurationHiddenElements,
          action.payload.user,
          action.payload.serverConfig,
        )
      }

      const oldHiddenQuantities = getStorageValue(
        action.payload.before + configurationHiddenQuantitiesFilter,
        action.payload.user,
        action.payload.serverConfig,
      )
      if (oldHiddenQuantities) {
        setStorageValue(
          action.payload.after + configurationHiddenQuantitiesFilter,
          action.payload.user,
          action.payload.serverConfig,
          oldHiddenQuantities,
        )

        removeStorageValue(
          action.payload.before + configurationHiddenQuantitiesFilter,
          action.payload.user,
          action.payload.serverConfig,
        )
      }

      const oldStoredGridLayout = getStorageValue(
        action.payload.before + configurationGridLayout,
        action.payload.user,
        action.payload.serverConfig,
      )

      if (oldStoredGridLayout) {
        setStorageValue(
          action.payload.after + configurationGridLayout,
          action.payload.user,
          action.payload.serverConfig,
          oldStoredGridLayout,
        )

        removeStorageValue(
          action.payload.before + configurationGridLayout,
          action.payload.user,
          action.payload.serverConfig,
        )
      }
    },
    saveDefaultConfigurations: (state, action) => {
      const space = WorkSpaces[action.payload.publicWorkspace]
      if (!space) return
      encryptLocalStorageValue(
        action.payload.publicWorkspace + configurationHiddenElements,
        JSON.stringify(space[configurationHiddenElements.substring(1)]),
        action.payload.user,
        action.payload.serverConfig,
      )
      if (action.payload.profileWorkspaces) {
        const profileWorkspaces = action.payload.profileWorkspaces
        profileWorkspaces.forEach(element => {
          const space = WorkSpaces[element]
          if (!space) return
          encryptLocalStorageValue(
            element + configurationHiddenElements,
            JSON.stringify(space[configurationHiddenElements.substring(1)]),
            action.payload.user,
            action.payload.serverConfig,
          )
        })
      }
    },
    setIsConfigurationModalOpen: (state, action) => {
      state.isConfigurationModalOpen = action.payload
    },
    setIsConfigurationEditModalOpen: (state, action) => {
      state.isConfigurationEditModalOpen = action.payload
    },
    setFormConfigurationValue: (state, action) => {
      state.formConfigurationValue = action.payload
    },
    setBarcodeOptionsValues: (state, action) => {
      if (action.payload && Object.keys(action.payload).length !== 0) {
        //state.CodicePersonalizzazione = action.CodicePersonalizzazione ? action.CodicePersonalizzazione : "SCOUT";

        state.BarcodeClientiTipo = action.payload.BarcodeClientiTipo
          ? action.payload.BarcodeClientiTipo.toLowerCase()
          : BarcodeClientiTipo_Tek
        state.EAN13Atelier98 = action.payload.EAN13Atelier98
          ? action.payload.EAN13Atelier98.toLowerCase()
          : EAN13Atelier98_Siepuri
        state.Barcode12Atelier98 = action.payload.Barcode12Atelier98
          ? action.payload.Barcode12Atelier98.toLowerCase()
          : Barcode12Atelier98_Si
        state.Barcode14Tipo = action.payload.Barcode14Tipo
          ? action.payload.Barcode14Tipo.toLowerCase()
          : Barcode14Tipo_Mav

        state.Barcode13Come12 = action.payload.Barcode13Come12
          ? action.payload.Barcode13Come12.toLowerCase()
          : Barcode13Come12_No
        state.BarcodeGrigliaVentilazione = action.payload.BarcodeGrigliaVentilazione
          ? action.payload.BarcodeGrigliaVentilazione.toLowerCase()
          : BarcodeGrigliaVentilazione_No
      }
    },
    setAllMarketplace: (state, action) => {
      state.allMarketplace = action.payload
    },
    setProfileValue: (state, action) => {
      state.profileValue = action.payload
    },
    setUserValue: (state, action) => {
      state.userValue = action.payload
    },
    setGDPR: (state, action) => {
      state.GDPR = action.payload
    },
    setOmnichannelModule: (state, action) => {
      state.omnichannelModule = action.payload
    },
    setPimModule: (state, action) => {
      state.pimModule = action.payload
    },
    setLimitQtyModule: (state, action) => {
      state.limitQtyModule = action.payload
    },
    setOmnichannelStoreModule: (state, action) => {
      state.omnichannelStoreModule = action.payload
    },
    setOmnichannelSiteModule: (state, action) => {
      state.omnichannelSiteModule = action.payload
    },
    setCausaliAmmesse: (state, action) => {
      state.causaliAmmesse = action.payload
    },
    setNegoziContoVendita: (state, action) => {
      state.negoziContoVendita = action.payload
    },
    setNegozioHome: (state, action) => {
      state.negozioHome = action.payload
    },
    setNegoziVicini: (state, action) => {
      state.negoziVicini = action.payload
    },
    setNegoziLontani: (state, action) => {
      state.negoziLontani = action.payload
    },
    setNegoziEscludere: (state, action) => {
      state.negoziEscludere = action.payload
    },
    setB2BMarketplaceValue: (state, action) => {
      state.showB2BLine = action.payload
    },
    setMovementTabVisible: (state, action) => {
      state.workspaceMovementVisible = action.payload
    },
    setAvailabilityTabVisible: (state, action) => {
      state.workspaceAvailabilityVisible = action.payload
    },
    setQuantitiesTabVisible: (state, action) => {
      state.workspaceQuantitiesVisible = action.payload
    },
    setMarketplaceAvailabilitiesTabVisibile: (state, action) => {
      state.workspaceMarketplaceAvailabilitiesVisible = action.payload
    },
    setShowFilterElement: (state, action) => {
      state.workspaceFilterElementVisible = action.payload
    },
    setShowBarcodeElement: (state, action) => {
      state.workspaceBarcodeElementVisible = action.payload
    },
    setShowEditButtonElement: (state, action) => {
      state.workspaceDiwaEditVisible = action.payload
    },
    setShowDimensionLocalElement: (state, action) => {
      state.workspaceDimensionLocalVisible = action.payload
    },
    setShowDimensionNearbyElement: (state, action) => {
      state.workspaceDimensionNearbyVisible = action.payload
    },
    setShowDimensionRemoteElement: (state, action) => {
      state.workspaceDimensionRemoteVisible = action.payload
    },
    setShowInterrogationTypeElement: (state, action) => {
      state.workspaceInterrogationTypeElementVisible = action.payload
    },
    setShowConfigurationElement: (state, action) => {
      state.workspaceWorkspaceDropdownVisible = action.payload
    },
    setShowPredefinedFilterElement: (state, action) => {
      state.workspacePredefinedFiltersVisible = action.payload
    },
    setShowExtraFilterElement: (state, action) => {
      state.workspaceExtraFiltersVisible = action.payload
    },
    setShwoPriceFilterElement: (state, action) => {
      state.workspacePriceFiltersVisible = action.payload
    },
    setShowOptionalFilterElement: (state, action) => {
      state.workspaceOptionalFiltersVisible = action.payload
    },
    setShowWebAndMarketingFilterElement: (state, action) => {
      state.webAndMarketingFiltersVisible = action.payload
    },
    setActiveTheme: (state, action) => {
      state.activeTheme = action.payload.theme

      encryptLocalStorageValue(configurationTheme, state.activeTheme, action.payload.user, action.payload.serverConfig)
    },
    loadActiveTheme: (state, action) => {
      const activeTheme = decryptLocalStorageValue(configurationTheme, action.payload.user, action.payload.serverConfig)

      state.activeTheme = activeTheme ? activeTheme : LightTheme
    },
    setPurchasePriceVisible: (state, action) => {
      state.isPurchasePriceVisibile = !(action.payload === 'NO' || action.payload === 'NI')
    },
    setAllPricelists: (state, action) => {
      state.allPricelists = action.payload
    },
  },
  extraReducers: builder => {
    builder.addMatcher(IsSaveBarcode, (state, action) => {
      if (state.isConfigurationModalOpen) {
        state.isConfigurationModalOpen = false
      }

      if (state.isConfigurationEditModalOpen) {
        state.isConfigurationEditModalOpen = false
      }
    })
  },
})

// Action creators are generated for each case reducer function
export const {
  savePublicWorkspace,
  saveProfileWorkspaces,
  saveIntegrationInfo,
  setValue,
  setActiveStore,
  loadConfiguration,
  saveConfiguration,
  deleteConfiguration,
  renameConfiguration,
  setIsConfigurationModalOpen,
  setIsConfigurationEditModalOpen,
  setFormConfigurationValue,
  setBarcodeOptionsValues,
  setAllMarketplace,
  setProfileValue,
  setUserValue,
  setB2BMarketplaceValue,
  setMovementTabVisible,
  setAvailabilityTabVisible,
  setQuantitiesTabVisible,
  setMarketplaceAvailabilitiesTabVisibile,
  setShowFilterElement,
  setShowBarcodeElement,
  setShowEditButtonElement,
  setShowDimensionLocalElement,
  setShowDimensionNearbyElement,
  setShowDimensionRemoteElement,
  setShowInterrogationTypeElement,
  setShowConfigurationElement,
  setShowPredefinedFilterElement,
  setShowExtraFilterElement,
  setShwoPriceFilterElement,
  setShowOptionalFilterElement,
  setShowWebAndMarketingFilterElement,
  setActiveTheme,
  saveDefaultConfigurations,
  loadProfileOptions,
  loadActiveTheme,
  setPurchasePriceVisible,
  setGDPR,
  setOmnichannelModule,
  setPimModule,
  setLimitQtyModule,
  setOmnichannelStoreModule,
  setOmnichannelSiteModule,
  setCausaliAmmesse,
  setNegoziContoVendita,
  setNegozioHome,
  setNegoziVicini,
  setNegoziLontani,
  setNegoziEscludere,
  setAllPricelists,
  isFromMVMode,
} = configurationSlice.actions

export default configurationSlice.reducer
